ControlBinders.register(`[data-cta-bar]`, (e) => {    
    const buttons = e.querySelectorAll('.button');
    if (buttons && buttons.length > 0) {
        document.querySelector("body").classList.add("has-cta-bar");        
    }    
});
